export enum NotificationPermissionStatus {
    /**
     * The user has explicitly granted permission for the current origin to display system notifications
     */
    Granted = 'granted',
    /**
     * The user has explicitly denied permission for the current origin to display system notifications
     */
    Denied = 'denied',
    /**
     * The user decision is unknown
     */
    Default = 'default',
}
